/** Which glyph AgentKindIcon renders — distinct from AgentDelegationKind (the transport-level
 *  LOCAL_MCP_CODING | AGENT_RUN), which is a dispatch mechanism, not a presentation identity.
 *  LOCAL_CLAUDE maps from AgentDelegationKind.LOCAL_MCP_CODING; everything else (AGENT_RUN,
 *  or no delegation at all — e.g. executor-attention-only presence) renders as ASSISTANT. */
export enum AgentPresenceAgentKind {
  LOCAL_CLAUDE = 'LOCAL_CLAUDE',
  ASSISTANT = 'ASSISTANT',
}
